import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";

const float1 = keyframes`
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(80px, -40px) scale(1.1); }
  100% { transform: translate(0, 0) scale(1); }
`;

const float2 = keyframes`
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-60px, 60px) scale(1.15); }
  100% { transform: translate(0, 0) scale(1); }
`;

export const BackgroundShapes = () => {
  return (
    <Box
      position="absolute"
      inset={0}
      overflow="hidden"
      zIndex={0}
    >
      {/* Blob 1 */}
      <Box
        position="absolute"
        top="-120px"
        left="-120px"
        width="420px"
        height="420px"
        bg="#007188"
        opacity={0.18}
        borderRadius="full"
        filter="blur(120px)"
        animation={`${float1} 20s ease-in-out infinite`}
      />

      {/* Blob 2 */}
      <Box
        position="absolute"
        bottom="-140px"
        right="-100px"
        width="460px"
        height="460px"
        bg="#024856"
        opacity={0.2}
        borderRadius="full"
        filter="blur(140px)"
        animation={`${float2} 26s ease-in-out infinite`}
      />
    </Box>
  );
};
